/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* User Permission.
*/
export enum PermissionType {
  PermissionIdUnspecified = 'permission_id_unspecified',
  GlobalSettingsView = 'global_settings.view',
  VaultAccountsManage = 'vault_accounts.manage',
  CostExplorerView = 'cost_explorer.view',
  UserAccessManage = 'user_access.manage',
  SamlGroupAccessManage = 'saml_group_access.manage',
  ApiCredentialsManage = 'api_credentials.manage',
  ApiCredentialsRotateSecret = 'api_credentials.rotate_secret',
  CustomRolesManage = 'custom_roles.manage',
  DashboardView = 'dashboard.view',
  InventoryView = 'inventory.view',
  JobsView = 'jobs.view',
  AuditLogsView = 'audit_logs.view',
  BackupSettingsView = 'backup_settings.view',
  StorageGatewayView = 'storage_gateway.view',
  DatabaseExplorerSearch = 'database_explorer.search',
  FileExplorerSearch = 'file_explorer.search',
  SnapshotsTakeOrConvert = 'snapshots.take_or_convert',
  ResourcesRestore = 'resources.restore',
  ConfigurationValidate = 'configuration.validate',
  FilesRestore = 'files.restore',
  DatabasesQuery = 'databases.query',
  DataClassesOverride = 'data_classes.override',
  EnvironmentsOverride = 'environments.override',
  DetectedAppsOverride = 'detected_apps.override',
  ControlViolationsMute = 'control_violations.mute',
  BackupExclusionManage = 'backup_exclusion.manage',
  VaultsManage = 'vaults.manage',
  SourceAccountsManage = 'source_accounts.manage',
  RestoreAccountsManage = 'restore_accounts.manage',
  BackupPoliciesManage = 'backup_policies.manage',
  DiscoveryConfigurationManage = 'discovery_configuration.manage',
  BackupConfigurationManage = 'backup_configuration.manage',
  ControlsManage = 'controls.manage',
  RansomwareDetectionManage = 'ransomware_detection.manage',
  NotificationPoliciesManage = 'notification_policies.manage',
  StorageGatewayManage = 'storage_gateway.manage'
}
